<template>
  <div class="row">
    <div class="col-12 pb-2">
      <strong>NOME - CONTROLE</strong>
    </div>
    <div class="col-12 table-responsive">
      <table class="table-hover" style="border: 1px solid #dcdede; width: 100%; background-color: #f5f5f5;" border="1">
        <tbody>
          <tr style="border: 1px solid #dcdede;" v-for="i in repeat" :key="i" :value="i">
            <td class="text-left pl-2 pr-2" style="width: 90%">
              <a href="" style="font-size: 11px; color: #505050;">
                0{{i}} - ITEM DE CONTROLE
              </a>
            </td>
            <td class="text-center" style="width: 2%">
              <b-form-checkbox v-model="status" value="accepted" unchecked-value="not_accepted" style="padding-left: 1.9rem; margin-right: 0rem;" />
            </td>
            <td class="text-center pl-2 pr-2" style="width: 2%">
              <a href="" style="color: #505050;">
                <i class="fas fa-paperclip"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'week',
  data () {
    return {
      status: null,
      repeat: 5
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/sg/agenda/week.vue